"use client";

import Image from "next/image";
import AnimatedContent from "../AnimatedContent";
import { useTranslation } from "react-i18next";
import SectionContainer from "@/common/SectionContainer";

const ProblemSection = () => {
  const { t } = useTranslation();

  const problems = [
    {
      id: 1,
      tag: "PROBLEM_SECTION_LIST_TAG_1",
      title: "PROBLEM_SECTION_LIST_TITLE_1",
      description: "PROBLEM_SECTION_LIST_DESCRIPTION_1",
      image:
        "https://zipshow-static-web.s3.ap-northeast-2.amazonaws.com/homepage/color-to-life-biz/problem_image_1.png",
      align: "right",
    },
    {
      id: 2,
      tag: "PROBLEM_SECTION_LIST_TAG_2",
      title: "PROBLEM_SECTION_LIST_TITLE_2",
      description: "PROBLEM_SECTION_LIST_DESCRIPTION_2",
      image:
        "https://zipshow-static-web.s3.ap-northeast-2.amazonaws.com/homepage/color-to-life-biz/problem_image_2.png",
      align: "left",
    },
  ];

  const problemCards = [
    {
      image:
        "https://zipshow-static-web.s3.ap-northeast-2.amazonaws.com/homepage/color-to-life-biz/problem_image_3.png",
      title: "PROBLEM_SECTION_CARD_TITLE_1",
      description: "PROBLEM_SECTION_CARD_DESCRIPTION_1",
    },
    {
      image:
        "https://zipshow-static-web.s3.ap-northeast-2.amazonaws.com/homepage/color-to-life-biz/problem_image_4.png",
      title: "PROBLEM_SECTION_CARD_TITLE_2",
      description: "PROBLEM_SECTION_CARD_DESCRIPTION_2",
    },
    {
      image:
        "https://zipshow-static-web.s3.ap-northeast-2.amazonaws.com/homepage/color-to-life-biz/problem_image_2.png",
      title: "PROBLEM_SECTION_CARD_TITLE_3",
      description: "PROBLEM_SECTION_CARD_DESCRIPTION_3",
    },
  ];

  return (
    <SectionContainer
      id="problem-section"
      className="section-shell bg-blue-50 text-gray-900"
    >
      <div className="section-inner flex flex-col">
        {/* 문제점 ① / ② */}
        {problems.map((item, index) => (
          <AnimatedContent
            key={item.id}
            className={`grid grid-cols-1 lg:grid-cols-2 items-center md:items-start gap-12 lg:gap-20 ${
              index === problems.length - 1 ? "pb-20" : "pb-40"
            }`}
          >
            {/* 텍스트 */}
            <div
              className={`flex flex-col justify-center gap-6 md:gap-8 text-center lg:text-left md:pt-[10%] order-1 ${
                item.align === "right" ? "lg:order-1" : "lg:order-2"
              }`}
            >
              <div className="bg-gradient-to-r from-[#5BBF4D]/80 to-[#207AE8]/80 text-white font-semibold text-[clamp(1rem,1.8vw,1.25rem)] py-1 px-4 rounded-xl w-fit mx-auto lg:mx-0">
                {t(item.tag)}
              </div>

              <h3 className="section-title">{t(item.title)}</h3>
              <p className="max-w-xl text text-gray-600 whitespace-pre-wrap">
                {t(item.description)}
              </p>
            </div>

            {/* 이미지 */}
            <div
              className={`relative w-full aspect-4/3 rounded-md overflow-hidden shadow-lg order-2 ${
                item.align === "right" ? "lg:order-2" : "lg:order-1"
              }`}
            >
              <Image
                src={item.image}
                alt={item.title}
                fill
                quality={90}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                className="object-cover"
              />
            </div>
          </AnimatedContent>
        ))}

        {/* 공통 한계 카드 + 결론 */}
        <AnimatedContent className="text-center border-t border-gray-200 pt-20 space-y-14 md:space-y-20">
          {/* 카드 그룹 */}
          <div className="max-w-[1400px] w-full mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {problemCards.map((card) => (
              <div
                key={card.title}
                className="relative aspect-4/3 md:aspect-square rounded-2xl overflow-hidden shadow-md group hover:shadow-lg transition-all duration-300"
              >
                <Image
                  src={card.image}
                  alt={card.title}
                  fill
                  quality={85}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 360px"
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent flex flex-col justify-end items-center p-5">
                  <p className="font-semibold text-white text-[clamp(1rem,1.5vw,1.125rem)] mb-1">
                    {t(card.title)}
                  </p>
                  <p className="label w-fit">{t(card.description)}</p>
                </div>
              </div>
            ))}
          </div>

          {/* 결론 문장 */}
          <p className="text font-medium text-gray-800 mx-auto">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#5BBF4D] to-[#207AE8] font-bold">
              {t("PROBLEM_SECTION_CONCLUSION_POINT")}
            </span>{" "}
            {t("PROBLEM_SECTION_CONCLUSION")}
          </p>
        </AnimatedContent>
      </div>
    </SectionContainer>
  );
};

export default ProblemSection;
